import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from './store'
import { AppParamsContextProvider } from './context/AppParamsContext';

const root = ReactDOM.createRoot(document.getElementById('app'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppParamsContextProvider>
        <App />
      </AppParamsContextProvider>
    </Provider>
  </React.StrictMode>
);